import { Link } from 'react-router-dom';

import { Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { ROUTES } from '@openclassrooms/routing';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';

import Logo, { LOGO_VARIANTS } from '../../components/Logo';

const useStyles = makeStyles(
  ({ breakpoints, spacing, palette, zIndex }) => ({
    root: {
      height: spacing(7),
      position: 'relative',
      zIndex: zIndex.appBar,
    },
    logoContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
    },
    mainWrapper: {
      display: 'flex',
      height: '100%',
      alignItems: 'center',
    },
    content: {
      flexGrow: 1,
    },
    logoCompactContainer: {
      display: 'flex',
      alignItems: 'center',
      '&:after': {
        content: '""',
        height: spacing(4),
        width: 1,
        backgroundColor: palette.layout.line.divider,
        marginLeft: spacing(2),
        marginRight: spacing(2),
      },
    },
    logoRootCompact: {
      width: 32,
      height: 32,
      display: 'block',
    },
    [breakpoints.up('sm')]: {
      root: {
        height: 64,
      },
      logoRootCompact: {
        width: 40,
        height: 40,
      },
    },
  }),
  { classNamePrefix: 'BusinessContactHeader' }
);

function BusinessContactHeader() {
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={2} square>
      <ContentWrapper className={classes.mainWrapper}>
        <div className={classes.logoCompactContainer}>
          <Link to={ROUTES.HOMEPAGE.INDEX} className={classes.link}>
            <Logo
              variant={LOGO_VARIANTS.COMPACT_BACKGROUND}
              classes={{ root: classes.logoRootCompact }}
            />
          </Link>
        </div>
      </ContentWrapper>
    </Paper>
  );
}

export default BusinessContactHeader;
